import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { UTILITIES } from "../../core/utility/utilities";
import { AppService } from "src/app/app.service";
@Component({
  selector: "app-payment-success-popup",
  templateUrl: "./payment-success-popup.component.html",
  styleUrls: ["./payment-success-popup.component.scss"],
})
export class PaymentSuccessPopupComponent implements OnInit {
  paymentSuccess;
  @Input() plan;
  @Input() order: any;
  @Input() planData;

  iosDevice = this.utilities.isDeviceiOS();
  constructor(
    public modalController: ModalController,
    private utilities: UTILITIES,
    private appService: AppService,
) {}

  ngOnInit() {
    this.getOnePlan()
  }

  close(flag) {
    this.modalController.dismiss(flag);
  }

  getOnePlan() {
    this.appService.getOnePlan().then((res) => {
      this.planData = res;
      console.log('planData: ', this.planData);
      if (this.planData.planType == "premium" && this.planData.planCouponCode && (this.planData.planCouponCode.toLowerCase().indexOf('sm') > -1)) {
        this.planData.smartPlan = true;
      }
    })
  }
}
